import React from 'react'

import Script from 'dangerous-html/react'

import './footer.css'

const Footer = (props) => {
  return (
    <div className="footer-container1">
      <div className="footer-container2">
        <div className="footer-container3">
          <Script
            html={`<style>
@media (prefers-reduced-motion: reduce) {
.footer-wave-svg, .footer-logo-text, .footer-social-link, .footer-social-link svg, .footer-nav-link, .footer-contact-item, .footer-contact-icon, .footer-scroll-top {
  animation: none;
  transition: none;
}
.footer-divider::after {
  animation: none;
}
.footer-column-title::after {
  animation: none;
}
}
</style>`}
          ></Script>
        </div>
      </div>
      <footer className="footer">
        <div className="footer-wave-divider">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1440 120"
            preserveAspectRatio="none"
            className="footer-wave-svg"
          >
            <path
              d="M0,64 C240,20 480,0 720,20 C960,40 1200,80 1440,64 L1440,120 L0,120 Z"
              fill="currentColor"
            ></path>
          </svg>
        </div>
        <canvas
          id="footerParticles"
          aria-hidden="true"
          className="footer-particle-canvas"
        ></canvas>
        <div className="footer-content-wrapper">
          <div className="footer-grid">
            <div className="footer-brand-column">
              <div className="footer-brand-logo">
                <span className="footer-logo-text">SilkTechnologies</span>
              </div>
              <p className="footer-brand-tagline section-content">
                Empowering innovation through cutting-edge technology solutions
              </p>
              <div className="footer-social-links">
                <a href="#">
                  <div aria-label="GitHub" className="footer-social-link">
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5c.08-1.25-.27-2.48-1-3.5c.28-1.15.28-2.35 0-3.5c0 0-1 0-3 1.5c-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.4 5.4 0 0 0 4 9c0 3.5 3 5.5 6 5.5c-.39.49-.68 1.05-.85 1.65S8.93 17.38 9 18v4"></path>
                        <path d="M9 18c-4.51 2-5-2-7-2"></path>
                      </g>
                    </svg>
                  </div>
                </a>
                <a href="#">
                  <div aria-label="LinkedIn" className="footer-social-link">
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2a2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6M2 9h4v12H2z"></path>
                        <circle r="2" cx="4" cy="4"></circle>
                      </g>
                    </svg>
                  </div>
                </a>
                <a href="#">
                  <div aria-label="Twitter" className="footer-social-link">
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6c2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4c-.9-4.2 4-6.6 7-3.8c1.1 0 3-1.2 3-1.2"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </div>
                </a>
              </div>
            </div>
            <div className="footer-links-column">
              <h3 className="footer-column-title">Company</h3>
              <nav className="footer-nav">
                <a href="#">
                  <div className="footer-nav-link">
                    <span>About Us</span>
                  </div>
                </a>
                <a href="#">
                  <div className="footer-nav-link">
                    <span>Careers</span>
                  </div>
                </a>
                <a href="#">
                  <div className="footer-nav-link">
                    <span>Press Kit</span>
                  </div>
                </a>
                <a href="#">
                  <div className="footer-nav-link">
                    <span>Contact</span>
                  </div>
                </a>
              </nav>
            </div>
            <div className="footer-links-column">
              <h3 className="footer-column-title">Services</h3>
              <nav className="footer-nav">
                <a href="#">
                  <div className="footer-nav-link">
                    <span>Web Development</span>
                  </div>
                </a>
                <a href="#">
                  <div className="footer-nav-link">
                    <span>Cloud Solutions</span>
                  </div>
                </a>
                <a href="#">
                  <div className="footer-nav-link">
                    <span>AI Integration</span>
                  </div>
                </a>
                <a href="#">
                  <div className="footer-nav-link">
                    <span>Consulting</span>
                  </div>
                </a>
              </nav>
            </div>
            <div className="footer-contact-column">
              <h3 className="footer-column-title">Get in Touch</h3>
              <div className="footer-contact-list">
                <div className="footer-contact-item">
                  <div className="footer-contact-icon">
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="m22 7l-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
                        <rect x="2" y="4" rx="2" width="20" height="16"></rect>
                      </g>
                    </svg>
                  </div>
                  <span className="footer-contact-text">
                    hello@neonflux.tech
                  </span>
                </div>
                <div className="footer-contact-item">
                  <div className="footer-contact-icon">
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1 2-2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233a14 14 0 0 0 6.392 6.384"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </div>
                  <span className="footer-contact-text">+1 (555) 123-4567</span>
                </div>
                <div className="footer-contact-item">
                  <div className="footer-contact-icon">
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M17.97 9.304A8 8 0 0 0 2 10c0 4.69 4.887 9.562 7.022 11.468m12.356-4.842a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z"></path>
                        <circle r="3" cx="10" cy="10"></circle>
                      </g>
                    </svg>
                  </div>
                  <span className="footer-contact-text">San Francisco, CA</span>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-divider"></div>
          <div className="footer-bottom">
            <p className="footer-copyright section-content">
              &amp;copy; 2025 NeonFlux. All rights reserved.
            </p>
            <div className="footer-legal-links">
              <a href="#">
                <div className="footer-legal-link">
                  <span>Privacy Policy</span>
                </div>
              </a>
              <a href="#">
                <div className="footer-legal-link">
                  <span>Terms of Service</span>
                </div>
              </a>
              <a href="#">
                <div className="footer-legal-link">
                  <span>Cookie Policy</span>
                </div>
              </a>
            </div>
          </div>
          <button
            id="scrollTopBtn"
            aria-label="Scroll to top"
            className="footer-scroll-top"
          >
            <svg
              width="24"
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                d="m5 12l7-7l7 7m-7 7V5"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
            </svg>
          </button>
        </div>
      </footer>
      <div className="footer-container4">
        <div className="footer-container5">
          <Script
            html={`<style>
        @keyframes waveFloat {0%,100% {transform: translateY(0) scaleY(1);}
50% {transform: translateY(-8px) scaleY(1.05);}}@keyframes neonGlow {0%,100% {filter: brightness(1) drop-shadow(0 0 8px currentColor);}
50% {filter: brightness(1.3) drop-shadow(0 0 20px currentColor);}}@keyframes underlineGlow {0%,100% {opacity: 0.6;
width: 40px;}
50% {opacity: 1;
width: 60px;}}@keyframes shimmer {0% {left: -100%;}
100% {left: 200%;}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="footer-container6">
        <div className="footer-container7">
          <Script
            html={`<script defer data-name="footer-particles-scroll">
(function(){
  const canvas = document.getElementById("footerParticles")
  const ctx = canvas.getContext("2d")
  const scrollTopBtn = document.getElementById("scrollTopBtn")

  let particles = []
  let animationId

  function resizeCanvas() {
    canvas.width = canvas.offsetWidth
    canvas.height = canvas.offsetHeight
  }

  class Particle {
    constructor() {
      this.reset()
      this.y = Math.random() * canvas.height
    }

    reset() {
      this.x = Math.random() * canvas.width
      this.y = -10
      this.speed = 0.2 + Math.random() * 0.5
      this.size = 1 + Math.random() * 2
      this.opacity = Math.random() * 0.5 + 0.3
      this.drift = (Math.random() - 0.5) * 0.3
    }

    update() {
      this.y += this.speed
      this.x += this.drift

      if (this.y > canvas.height || this.x < 0 || this.x > canvas.width) {
        this.reset()
      }
    }

    draw() {
      ctx.fillStyle = \`rgba(100, 200, 255, \${this.opacity})\`
      ctx.beginPath()
      ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2)
      ctx.fill()
    }
  }

  function initParticles() {
    particles = []
    const particleCount = Math.floor((canvas.width * canvas.height) / 8000)
    for (let i = 0; i < particleCount; i++) {
      particles.push(new Particle())
    }
  }

  function animate() {
    ctx.clearRect(0, 0, canvas.width, canvas.height)

    particles.forEach((particle) => {
      particle.update()
      particle.draw()
    })

    for (let i = 0; i < particles.length; i++) {
      for (let j = i + 1; j < particles.length; j++) {
        const dx = particles[i].x - particles[j].x
        const dy = particles[i].y - particles[j].y
        const distance = Math.sqrt(dx * dx + dy * dy)

        if (distance < 120) {
          ctx.strokeStyle = \`rgba(100, 200, 255, \${0.15 * (1 - distance / 120)})\`
          ctx.lineWidth = 0.5
          ctx.beginPath()
          ctx.moveTo(particles[i].x, particles[i].y)
          ctx.lineTo(particles[j].x, particles[j].y)
          ctx.stroke()
        }
      }
    }

    animationId = requestAnimationFrame(animate)
  }

  function handleScroll() {
    if (window.scrollY > 500) {
      scrollTopBtn.classList.add("footer-scroll-top-visible")
    } else {
      scrollTopBtn.classList.remove("footer-scroll-top-visible")
    }
  }

  scrollTopBtn.addEventListener("click", () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    })
  })

  window.addEventListener("scroll", handleScroll)
  window.addEventListener("resize", () => {
    resizeCanvas()
    initParticles()
  })

  resizeCanvas()
  initParticles()
  animate()
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default Footer
